"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getErrorText = exports.NotificationTypes = void 0;
const composition_api_1 = require("@nuxtjs/composition-api");
const shortid_1 = __importDefault(require("shortid"));
var NotificationTypes;
(function (NotificationTypes) {
    NotificationTypes["INFO"] = "info";
    NotificationTypes["SUCCESS"] = "success";
    NotificationTypes["ERROR"] = "error";
    NotificationTypes["FATAL"] = "fatal";
})(NotificationTypes = exports.NotificationTypes || (exports.NotificationTypes = {}));
const getErrorText = (err, defaultMessage) => {
    var _a;
    if (typeof err === 'string') {
        return err;
    }
    if (Array.isArray(err)) {
        return (_a = err === null || err === void 0 ? void 0 : err[0]) === null || _a === void 0 ? void 0 : _a.message;
    }
    if (typeof err === 'object') {
        return err === null || err === void 0 ? void 0 : err.message;
    }
    return defaultMessage || 'Something went wrong';
};
exports.getErrorText = getErrorText;
const notifications = (0, composition_api_1.ref)([]);
const add = ({ message, title = '', category = '', meta = {}, type = NotificationTypes.INFO, id = shortid_1.default.generate(), }) => {
    notifications.value.push({
        title,
        message,
        category,
        type,
        meta,
        id,
    });
    return id;
};
const addError = (err, options) => add({
    ...options,
    type: NotificationTypes.ERROR,
    message: (0, exports.getErrorText)(err),
});
const addFatal = (err, options) => add({
    ...options,
    type: NotificationTypes.FATAL,
    message: (0, exports.getErrorText)(err, 'Something went terribly wrong'),
});
const addSuccess = (message, options) => add({
    ...options,
    type: NotificationTypes.SUCCESS,
    message,
});
const addInfo = (message, options) => add({
    ...options,
    type: NotificationTypes.INFO,
    message,
});
const remove = (id) => {
    notifications.value = notifications.value.filter((n) => n.id !== id);
};
function useNotifications() {
    return {
        add,
        addInfo,
        addFatal,
        addError,
        addSuccess,
        remove,
        notifications,
    };
}
exports.default = useNotifications;
//# sourceMappingURL=index.js.map